import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { CopyIcon, MoveIcon, TrashIcon } from "~/assets/svg/InterfaceIcon";
import Form from "~/common/components/Form";
import Select from "~/common/components/Select";
import { optionList } from "~/pages/round/RoundReg/Inquiry/util/optionData";
import InquiryAddress from "./cardType/InquiryAddress";
import InquiryAgree from "./cardType/InquiryAgree";
import InquiryAlternative from "./cardType/InquiryAlternative";
import InquiryChoice from "./cardType/InquiryChoice";
import InquiryDate from "./cardType/InquiryDate";
import InquiryFile from "./cardType/InquiryFile";
import InquiryLink from "./cardType/InquiryLink";
import InquiryLong from "./cardType/InquiryLong";
import InquiryShort from "./cardType/InquiryShort";
import InquiryTag from "./cardType/InquiryTag";
import InquiryText from "./cardType/InquiryText";
import Category from "./cardType/Category";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { useTranslation } from "react-i18next";
import InquirySelect from "./cardType/InquirySelect";
const InquiryCase = ({ card, idx }) => {
	const { type } = card;

	switch (type) {
		case "SHORT":
			return <InquiryShort card={card} idx={idx} />;
		case "LONG":
			return <InquiryLong card={card} idx={idx} />;
		case "CHOICE":
			return <InquiryChoice card={card} idx={idx} />;
		case "ALTERNATIVE":
			return <InquiryAlternative card={card} idx={idx} />;
		case "AGREE":
			return <InquiryAgree card={card} idx={idx} />;
		case "TEXT":
			return <InquiryText card={card} idx={idx} />;
		case "FILE":
			return <InquiryFile card={card} idx={idx} />;
		case "LINK":
			return <InquiryLink card={card} idx={idx} />;
		case "ADDRESS":
			return <InquiryAddress card={card} idx={idx} />;
		case "TAG":
			return <InquiryTag card={card} idx={idx} />;
		case "DATE":
			return <InquiryDate card={card} idx={idx} />;
		case "SELECT":
			return <InquirySelect card={card} idx={idx} />;
		case "MULTISELECT":
			return <InquirySelect card={card} idx={idx} />;
		default:
			return <InquiryShort card={card} idx={idx} />;
	}
};

const InquiryCardContent = ({ card, connectDragSource, idx }) => {
	const { t } = useTranslation();
	const { setListByTarget, handleInquiryCopyFields, handleInquiryDelete, changeRequired } =
		useContext(ApplyContext);

	const elementRef = useRef(null);

	connectDragSource(elementRef);

	const [selectResult, setSelectResult] = useState("SHORT");
	const inquiryForm = useForm();
	const selectResult22 = inquiryForm.watch("selectCardType") || "SHORT";

	useEffect(() => {
		setSelectResult(selectResult22);
	}, [selectResult22]);

	useEffect(() => {
		let target = {};
		if (card.type === "CATEGORY") {
			target = card;
		} else {
			switch (selectResult) {
				case "TEXT":
					target = {
						...card,
						type: selectResult,
						color: !card.color ? "red" : card.color,
						option: [],
					};
					break;
				case "CHOICE":
					target = {
						...card,
						type: selectResult,
						option: !card.option ? [] : card.option,
					};
					break;
				case "ALTERNATIVE":
					target = {
						...card,
						type: selectResult,
						option: [
							!card.option ? { title: "" } : card.option[0],
							!card.option ? { title: "" } : card.option[1],
						],
					};
					break;
				case "FILE":
					target = {
						...card,
						type: selectResult,
						description: card.description || "",
						option: [],
					};
					break;
				case "SHORT":
					target = {
						...card,
						type: selectResult,
						option: !card.option ? [] : card.option,
					};
					break;
				case "SELECT":
				case "MULTISELECT":
					target = {
						...card,
						type: selectResult,
						option: !card.option ? [] : card.option,
					};
					break;
				default:
					target = { ...card, type: selectResult, option: [] };
			}
		}
		setListByTarget(target);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectResult]);

	return card.type === "CATEGORY" ? (
		<Category card={card} elementRef={elementRef} />
	) : (
		<>
			<button ref={elementRef} className="btn-inquiry-move">
				<MoveIcon />
			</button>
			<InquiryCase card={card} idx={idx} />
			<div className="dynamic-setting">
				<Form useForm={inquiryForm}>
					<Select
						name="selectCardType"
						options={optionList}
						defaultValue={card.type}
						value={card.type || ""}
						disabled={card.disabled}
					/>
				</Form>
				<div className="inquiry-setting-bottom">
					<button
						type="button"
						className="btn-copy"
						onClick={() => handleInquiryCopyFields(card.order)}
						disabled={card.disabled}
					>
						<CopyIcon />
					</button>
					<button
						type="button"
						className="btn-trash"
						onClick={() => handleInquiryDelete(card.order)}
						disabled={card.disabled}
					>
						<TrashIcon />
					</button>
					<div className="divider" />
					<label className="switch">
						<input
							type="checkbox"
							checked={card.isRequired}
							value={card.isRequired}
							onChange={(e) => changeRequired(e, card.order)}
							disabled={card.disabled}
						/>
						<span className="slider round" />
						<span className="slider-label">
							{t("pages.applyFormMange.inputComponent.applyInquriy.slider-label")}
						</span>
					</label>
				</div>
			</div>
		</>
	);
};

export default InquiryCardContent;
